import type { ReactNode } from 'react';

import { Button } from '@nesso/ui/primitives/button';
import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from '@nesso/ui/primitives/dialog';

type Props = {
    title: string;
    onSave: () => void;
    onCancel: () => void;
    children: ReactNode;
};

export function TreatmentApproachesDialog({ title, onSave, onCancel, children }: Props) {
    return (
        <Dialog
            open
            onOpenChange={(next) => {
                if (!next) onCancel();
            }}
        >
            <DialogContent fullscreen showCloseButton={false}>
                <DialogHeader className="p-6 pb-0 text-left">
                    <DialogTitle>{title}</DialogTitle>
                </DialogHeader>

                <div className="flex flex-col flex-1 min-h-0 px-6 pt-6">{children}</div>

                <DialogFooter className="flex-row gap-2 p-6">
                    <Button type="button" variant="outline" className="flex-1" onClick={onCancel}>
                        Cancel
                    </Button>
                    <Button type="button" className="flex-1" onClick={onSave}>
                        Save
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
